import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/GridLegacy';

const StaticContentSkeleton = () => (
	<Grid container justifyContent='center'>
		<Grid item md={12} lg={10} sx={{ px: { xs: 5, md: 10 }, py: 8 }}>
			<Typography variant='h1'>
				<Skeleton width='65%' />
			</Typography>
			<Skeleton />
			<Skeleton />
			<Skeleton />
			<Skeleton />
			<Skeleton />
			<Skeleton />
		</Grid>
	</Grid>
);
export default StaticContentSkeleton;
